export const statusOptionsList = ['OK', 'Test', 'Sold', 'Decommissioned', 'RMA']

export const commonQualityIssues = [
  'Housing cracked', 'Bad speaker', 'Bad buttons', 'Battery issue',
  'Screen broken', 'Display mis-positioned', 'Bad charging pins',
  'Left LED bad', 'Right LED bad', 'Vibration defect', 'Duplicate MAC', 'opened'
]

export function statusBadge(status) {
  if (status === 'RMA') return 'danger'
  if (status === 'OK') return 'success'
  if (status === 'Test') return 'info'
  if (status === 'Sold') return 'secondary'
  if (status === 'Decommissioned') return 'dark'
  return 'secondary'
}

export function eventBadge(type) {
  const t = type.toLowerCase()
  if (t.includes('received') || t.includes('factory')) return 'primary'
  if (t.includes('delivered') || t.includes('sent')) return 'info'
  if (t.includes('returned')) return 'success'
  if (t.includes('repair')) return 'warning'
  if (t.includes('issue')) return 'danger'
  if (t.includes('rma')) return 'secondary'
  return 'dark'
}

export function formatDueDate(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('de-DE', { year: '2-digit', month: '2-digit', day: '2-digit' })
}

export function deadlineClass(device) {
  if (!device.dueDate) return ''
  return new Date(device.dueDate) < new Date() ? 'text-danger font-weight-bold' : 'text-success'
}

export function deadlineText(device) {
  if (!device.dueDate) return ''
  const diff = Math.ceil((new Date(device.dueDate) - new Date()) / (1000 * 60 * 60 * 24))
  if (diff > 0) return `${diff} days left`
  if (diff === 0) return 'due today'
  return `overdue ${Math.abs(diff)} days`
}